import { isEmpty } from 'lodash'
import {getActiveArchivedShortUrls, getReportingGroups, updateShortUrl, createReportingGroup, getDomainList, updateDomain, createShortUrl, updateReportingGroup} from '@/libs/api/api'
import { message, loader, logout, errorHandler, getImageUrl } from '@/libs/helper'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import {mapGetters} from 'vuex'

export default {
    name: 'ShortURLSettings',
    props: {
        organisationList: {
            type: Array,
            default: () => []
        },
        details: {
            type: Object,
            default: () => {}
        },
        changeOrganisation: {
            type: Function,
            default: () => {}
        }
    },

    computed: {
        ...mapGetters({
            userInformation: 'getUserInformation'
        }),
    },

    watch: {
        details (newValue) {
            if ( !isEmpty(newValue) ) {
                // fetch active urls
                this.fetchAllURLs()
                // fetch domains list
                if (newValue.type !== 'USER')
                this.getDomainListing()
            }
        },
        '$route' (to, from) {
            if (to.path !== from.path && to.name === pageRoute.shortURLSettingsRegisteredURL) {
                this.fetchAllURLs()
            }
        }
    },
    mounted () {
        // fetch active urls
        if(this.details.id || this.details._id) this.fetchAllURLs()
    },

    data () {
        return {
            isEmpty,
            showDropdown: false,
            activeUrls: [],
            archivedUrls: [],
            reportingGroups: [],
            totalCount: null,
            domainList: [],
            activeArchiveUrlsParams: ''
        }
    },
    methods: {
        // eslint-disable-next-line
        routeToSettingsPage (org) {
        },
        /**
         * fetch urls
         */
        async fetchAllURLs () {
            try {
                loader(this, true)
                // fetch active urls
                await this.fetchActiveArchiveUrls()
                // fetch archived urls
                await this.fetchActiveArchiveUrls(true)
                // fetch reporting groups
                await this.fetchreportingGroups()
                loader(this, false)
            } catch (err) {
                loader(this, false)
            }
        },

        params(data){
            this.activeArchiveUrlsParams = data
        },
        /**
         * fetch urls
         */
        async fetchActiveArchiveUrls (isArchived) {
            if (!this.details) return 
            // body for api
            const body = {
                entity_id: this.details._id || this.details.id,
                entity_type: this.details.type || 'ORGANISATION',
                is_archived: isArchived || false
            }
            // api call
            await getActiveArchivedShortUrls(body, this.activeArchiveUrlsParams)
            .then(response => {
                if (isArchived) this.archivedUrls = response.result.items || []
                else {
                    this.activeUrls = response.result.items || [] 
                    this.totalCount = response.result.total_count
                }
                
            })
            .catch(error => {
                console.error(error)
            })
        },

        /**
         * to fetch reporting groups
         */
        async fetchreportingGroups () {
            if (!this.details) return
            // body for api
            let body = {
                entity_id: this.details._id || this.details.id,
                entity_type: this.details.type || 'ORGANISATION'
            }
            // api call
            await getReportingGroups(body)
            .then(response => {
                this.reportingGroups = response.result || []
            }).catch(error => {
                console.error(error)
            })
        },

        /**
         * create reporting url
         */
        async createRegisterUrl (urlGroup) {
            try {
                loader(this, true)
                let body = {
                    entity_id: this.details._id || this.details.id,
                    entity_type: this.details.type || 'ORGANISATION',
                    ...urlGroup
                }
                let response = await createReportingGroup(body)
                this.reportingGroups.push(response.result) 
                message(this, constants.messageType.SUCCESS, 'URL Reporting group added successfully')   
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
            finally {
                loader(this, false)
            }
        },

        /**
         * convert active url to archive url
         * @param {*} url 
         */
        convertUrl (url, isActive) {
            if (isEmpty(url)) return
            // loader
            loader(this, true)
            // body for api
            let body = {}
            // convert archive to active
            if (isActive) {
                body = {
                    is_archived: false,
                    is_active: true
                }
            } 
            // convert active to archive
            else {
                body = {
                    is_archived: true,
                    is_active: false
                }
            }
            // api call
            updateShortUrl(body, url._id).then(() => {
                // fetch active urls
                this.fetchActiveArchiveUrls()
                // fetch archived urls
                this.fetchActiveArchiveUrls(true)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }).finally(() => {
                loader(this, false)
            })
        },

        /**
         * get domain listing
         */
        async getDomainListing () {
            let body = {
                organisation: this.details._id
            }
            // api call
            let response = await getDomainList(body);
            
            if (response && response.domain && response.domain.length > 0) {
                this.domainList = response.domain.filter((item) => item.is_short_url_registered)
            }
        },

        async addDomainURL (value) {
            try {
                let body = {
                    is_short_url_registered: true
                }
                let payload = {
                    organisation_id: value.organisation_id,
                    domain_id: value.domain_id
                }
                loader(this, true)
                await updateDomain(payload, body)
                this.addDomain = false
                this.getDomainListing()
                message(this, constants.messageType.SUCCESS, 'Domain added successfully')
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            } finally {
                loader(this, false) 
            }
            
        },
        
        async removeDomainUrl(domain) {
            try {
                let body = {
                    is_short_url_registered: false
                }
                let payload = {
                    organisation_id: this.details._id,
                    domain_id: domain._id
                }
                loader(this, true)
                await updateDomain(payload, body)
                this.getDomainListing()
                message(this, constants.messageType.SUCCESS, 'Domain removed successfully')
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            } finally {
                loader(this, false)
            }
            
        },
        /**
         * get loc image url
         * @param {*} data 
         * @returns 
         */
         getLocationImageUrl (data) {
            switch (data.type) {
                case constants.AUTHOR.key:
                    return getImageUrl(data && data.author_type && data.author_type.avatar_image);
                case constants.PUBLICATION.key:
                    return getImageUrl(data && data.publication_type && data.publication_type.avatar_image);
                case constants.PUBLISHER.key:
                    return getImageUrl(data && data.publisher_type && data.publisher_type.avatar_image);
                case constants.LIST.COLLECTION:
                    return getImageUrl(data && data.collection_type && data.collection_type.avatar_image); 
                case constants.ORGANISATIONS.ORGANISATION:
                    return getImageUrl(data && data.organisation_type && data.organisation_type.avatar_image);
                case 'USER':
                    return getImageUrl(data && data.user_type && data.user_type.avatar_image)
            }
        },

        /**
         * redirection handler
         * @param {*} data 
         */
        handleLocationRedirection (data) {
            if (data && data.type_id) {
                switch (data.type) {
                    case constants.AUTHOR.key:
                        this.$router.push({name: pageRoute.authorOverview, params: {id: data.type_id}})
                    break
                    case constants.PUBLICATION.key:
                        this.$router.push({name: pageRoute.publicationOverview, params: {id: data.type_id}})
                    break
                    case constants.PUBLISHER.key:
                        this.$router.push({name: pageRoute.publisherOverview, params: {id: data.type_id}})
                    break
                    case constants.ORGANISATIONS.ORGANISATION:
                        this.$router.push({name: pageRoute.organisationOverview, params: {id: data.type_id}})
                    break
                    case constants.LIST.COLLECTION:
                        if (data.sub_type && data.sub_type_id && data.sub_type === 'USER') {
                            this.$router.push({name: 'user-collections-page', params: {cid: data.type_id, id: data.sub_type_id}})
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.AUTHOR.key) {
                            this.$router.push({name: pageRoute.pageRoute.authorCollectionPage, params: {cid: data.type_id, id: data.sub_type_id}})
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.PUBLICATION.key) {
                            this.$router.push({name: pageRoute.pageRoute.publicationCollectionPage, params: {cid: data.type_id, id: data.sub_type_id}})
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.PUBLISHER.key) {
                            this.$router.push({name: pageRoute.pageRoute.publisherCollectionPage, params: {cid: data.type_id, id: data.sub_type_id}})
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.ORGANISATIONS.ORGANISATION) {
                            this.$router.push({name: pageRoute.pageRoute.organisationCollectionPage, params: {cid: data.type_id, id: data.sub_type_id}})
                        }
                        
                    break
                    case 'USER':
                        this.$router.push({name: pageRoute.usersOverview, params: {id: data.type_id}})
                }
            }
        },
        /**
         * get name for the route
         * @param {*} data 
         * @returns 
         */
        getLocationRouteName (data) {
            if (data && data.type_id) {
                switch (data.type) {
                    case constants.AUTHOR.key:
                        return (data.author_type && data.author_type.name) +` > overview`
                    case constants.PUBLICATION.key:
                        return `${data.publication_type && data.publication_type.name} > overview`
                    case constants.PUBLISHER.key:
                        return `${data.publisher_type && data.publisher_type.name} > overview`
                    case constants.ORGANISATIONS.ORGANISATION:
                        return `${data.organisation_type && data.organisation_type.name} > overview`
                    case constants.LIST.COLLECTION:
                        if (data.sub_type && data.sub_type_id && data.sub_type === 'USER') {
                            return `${data.user && data.user.screen_name} > collections`
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.AUTHOR.key) {
                            return `${data.author_type && data.author_type.name} > collections`
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.PUBLICATION.key) {
                            return `${data.publication_type && data.publication_type.name} > collections`
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.PUBLISHER.key) {
                            return `${data.publisher_type && data.publisher_type.name} > collections`
                        }
                        else if (data.sub_type && data.sub_type_id && data.sub_type === constants.ORGANISATIONS.ORGANISATION) {
                            return `${data.organisation_type && data.organisation_type.name} > collections`
                        }
                    break
                    case 'USER':
                        return `${data.user_type && data.user_type.screen_name} > overview`
                }
            }
        },
        async addShortUrl(payload) {
            try {
                loader(this, true)

                // Primary URL object, set the common and expected values
                let primary_url = {
                    type: this.details && this.details.type === 'USER'? 'USER':constants.ORGANISATIONS.ORGANISATION,
                    type_id: this.details._id,
                    redirection_type: 'EXTERNAL',
                    external_url: payload.valuesPrimary.valueExternal
                };

                // If the internal option is chosen, add the values corresponding to it
                if (payload.valuesPrimary && payload.valuesPrimary.redirection_type==='INTERNAL') {
                    const primary = payload.valuesPrimary.valueInternal
                    primary_url.type = this.details && this.details.type === 'USER'? 'USER': constants.ORGANISATIONS.ORGANISATION
                    primary_url.type_id = this.details._id || this.details.id
                    if (primary.type === constants.LIST.COLLECTION || primary.type === constants.LIST.DOSSIER) {
                        primary_url.sub_type = primary.type
                        primary_url.sub_type_id = primary._id
                    }
                    primary_url.redirection_type = 'INTERNAL'
                    delete primary_url.external_url
                }

                // Backup URL object, set the common and expected values
                let backup_url = {
                    type: this.details && this.details.type === 'USER'? 'USER': constants.ORGANISATIONS.ORGANISATION,
                    type_id: this.details._id,
                    redirection_type: 'EXTERNAL',
                    external_url: payload.valuesBackup.valueExternal
                };

                // If the internal option is chosen, add the values corresponding to it
                if(payload.valuesBackup.redirection_type==='INTERNAL') {
                    const backup = payload.valuesBackup.valueInternalBackup
                    backup_url.type = this.details && this.details.type === 'USER'? 'USER':constants.ORGANISATIONS.ORGANISATION
                    backup_url.type_id = this.details._id || this.details.id
                    if (backup.type === constants.LIST.COLLECTION || backup.type === constants.LIST.DOSSIER) {
                        backup_url.sub_type = backup.type
                        backup_url.sub_type_id = backup._id
                    }
                    backup_url.redirection_type = 'INTERNAL'
                    delete backup_url.external_url
                } 

                // Construct body for api
                let body = {
                    type: this.details.type || 'ORGANISATION',
                    type_id: this.details._id || this.details.id,
                    user:  this.userInformation.id,
                    primary_url: primary_url,
                    backup_url: backup_url,
                }
                if (this.details.type !== 'USER') body.organisation = this.details_id

                // api call
                let response = await createShortUrl(body)

                if (payload.valueReportingGroup) {
                    const bodyObject = {
                        short_url_ids: [response.shortUrlData._id]
                    }
                    await updateReportingGroup(bodyObject, payload.valueReportingGroup)
                }
                // fetch active urls
                this.fetchActiveArchiveUrls()
                // fetch archived urls
                this.fetchActiveArchiveUrls(true)
                // message
                message(this, constants.messageType.SUCCESS, 'Short URL added successfully.')
            } catch (error) {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            } finally {
                loader(this, false)
                this.openAddShortUrl = false
            }
        },
        async updateReporting(data) {
            try {
                loader(this, true)
                for (let i = 0; i < data.markedReporting.length; i++) {
                    let selctedRows = data.markedReporting[i]
                    const bodyObject = {
                        short_url_ids: [data.rowItem._id]
                    }
                    await updateReportingGroup(bodyObject, selctedRows)
                }
                message(this, constants.messageType.SUCCESS, 'Updated Successfully.')
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            } finally {
                loader(this, false)
            }
        },
        refreshPage () {
            this.fetchAllURLs()
        }
    }
}